import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails, IContractorAreaResponseDTO } from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class GetContractorByIdCommand extends IRequestCommand<ICommandResponse, ErrorDetails, IGetAreasByContractorIdCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'contractor/{contractorId}/carrier/{carrierId}';
    public override setParameters(parameters: IGetAreasByContractorIdCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorId}', parameters.contractorId);
        this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId);
    };
}

export interface IGetAreasByContractorIdCommandParameters extends ICommandParameters {
    contractorId: string;
    carrierId: string;
}

export interface IGetAreasByContractorIdResponse extends ICommandResponse {

}
